// extracted by mini-css-extract-plugin
module.exports = {"container":"ConsistencyTooltip_container__qyNME","content":"ConsistencyTooltip_content__bbJNV"};